import React from "react";
import { StyleSheet, Text, View } from "react-native";
import CheckIcon from "@assets/svg/CheckGreen";
import Photo from "./Photo";
import Comment from "./Comment";

import t from "@constants/localization";

const PATH = "screens/KYCSetup/UserPhotoSection";

const UserPhotoSection = (props) => {
  const {
    userPhoto = "",
    uploadUserPhoto = () => {},
    removeUserPhoto = () => {},

    disableUserPhotoSection = false,
    verified,
    rejectionComment = null,
  } = props;
  const { source = "" } = userPhoto;

  const title = disableUserPhotoSection
    ? verified
      ? t(`${PATH}/photo`).concat(t(`${PATH}/photoVerified`))
      : t(`${PATH}/photo`)
    : t(`${PATH}/uploadPhoto`);

  return (
    <View style={styles.photoContainer}>
      <Comment kycComment={rejectionComment} />
      <View style={{ flexDirection: "row", alignItems: "center" }}>
        {verified && (
          <CheckIcon
            fill="rgba(0,171,89,1)"
            size={20}
            style={{ marginRight: 5 }}
          />
        )}
        <Text style={styles.photoText}>{title}</Text>
      </View>
      <Photo
        disabled={disableUserPhotoSection}
        source={source}
        ctaText={t(`${PATH}/uploadPhoto`)}
        onUpload={uploadUserPhoto}
        onDelete={removeUserPhoto}
        deletable={true}
        style={{ borderWidth: 0 }}
        variant="short"
        imgStyle={{
          borderWidth: 1,
          borderRadius: 10,
          borderColor: "rgba(0,0,0,0.2)",
          width: "50%",
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  photoContainer: {
    justifyContent: "center",
    marginTop: 10,
    marginBottom: 10,
  },
  photoText: {
    marginVertical: 10,
    color: "black",
  },
});

export default UserPhotoSection;
